import { PureComponent } from "react";

import { Button, ButtonMode } from "components/Button/Button";
import { Icon, IconType } from "components/Icon/Icon";

import "./AnnouncementList.scss";

import type { Announcement } from "models/announcements";

export interface AnnouncementListProps {
  content: Announcement[];
  onDismissAnnouncement: (id: string) => void;
}

export class AnnouncementList extends PureComponent<AnnouncementListProps> {
  render() {
    return (
      <ul className="announcement-list">
        {this.props.content.map((item) => (
          <li key={item.Id} className={`type-${item.Severity}`}>
            <span className="message">{item.Message}</span>
            <Button
              className="action"
              onClick={() => {
                this.onClose(item.Id);
              }}
              mode={ButtonMode.Transparent}
              title="Dismiss"
            >
              <Icon type={IconType.CancelMark} />
            </Button>
          </li>
        ))}
      </ul>
    );
  }

  private onClose = (id: string) => {
    this.props.onDismissAnnouncement(id);
  };
}
